import _jsx from '@babel/runtime/helpers/jsx';
import React, { Fragment, useEffect } from 'react';
import 'prop-types';
import { componentEnhance } from '@vpp-frontend-components/component-enhance';
import { Message } from '@vpp-frontend-components/message';
import { generateKeyToComponent, updateComponentPositionWhenSticky } from '@vpp-frontend-components/common';
import classnames from 'classnames';
import { ActionCollapsable } from '@vpp-frontend-components/action-collapsable';
import { useTrackView } from '@vpp-frontend-components/hooks';
const DescriptionCustomMessage = _ref => {
  var _custom_message$body, _custom_message$body2;
  let {
    custom_message = null,
    namespace = null
  } = _ref;
  return /*#__PURE__*/React.createElement(Message, {
    className: namespace ? `${namespace}__message` : '',
    closeable: custom_message === null || custom_message === void 0 ? void 0 : custom_message.closeable,
    hierarchy: custom_message === null || custom_message === void 0 ? void 0 : custom_message.hierarchy,
    type: custom_message === null || custom_message === void 0 ? void 0 : custom_message.message_type
  }, /*#__PURE__*/_jsx("div", {
    className: namespace ? `${namespace}__message__text` : ''
  }, void 0, componentEnhance.jsx(custom_message === null || custom_message === void 0 || (_custom_message$body = custom_message.body) === null || _custom_message$body === void 0 ? void 0 : _custom_message$body.text, custom_message === null || custom_message === void 0 || (_custom_message$body2 = custom_message.body) === null || _custom_message$body2 === void 0 ? void 0 : _custom_message$body2.values)));
};
var _br;
const isCollapsable = collapsable => {
  var _Object$keys;
  return collapsable && ((_Object$keys = Object.keys(collapsable)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0;
};
const nl2br = text => text.split('\n').map(item => /*#__PURE__*/_jsx(Fragment, {}, generateKeyToComponent(item), item, _br || (_br = /*#__PURE__*/_jsx("br", {}))));
const DescriptionTextContent = _ref => {
  let {
    content,
    namespace = null
  } = _ref;
  return /*#__PURE__*/_jsx("p", {
    "data-testid": "content",
    className: namespace ? `${namespace}__content` : ''
  }, void 0, nl2br(content));
};
const namespace$1 = 'ui-pdp-description';
const Description = _ref => {
  var _custom_message$title;
  let {
    title = null,
    content,
    custom_message = null,
    className = '',
    showTitle = null,
    show_track = null,
    focus = false,
    onScrollComponent = null
  } = _ref;
  const refView = useTrackView(show_track, {
    threshold: 0.1
  });
  useEffect(() => {
    let timeoutId;

    /* istanbul ignore next */
    if (focus) {
      window.scrollTo({
        left: 0,
        top: refView.current.getBoundingClientRect().top + window.scrollY,
        behavior: 'smooth'
      });
      timeoutId = setTimeout(() => {
        onScrollComponent({
          focus: false
        });
      }, 1000);
    }
    return () => clearTimeout(timeoutId);
  }, [refView, focus, onScrollComponent]);
  return /*#__PURE__*/React.createElement("div", {
    ref: refView,
    className: classnames(namespace$1, className)
  }, title && showTitle && /*#__PURE__*/_jsx("h2", {
    "data-testid": "title",
    className: `${namespace$1}__title`
  }, void 0, title), custom_message && /*#__PURE__*/React.createElement(Message, {
    className: `${namespace$1}__message`,
    closeable: custom_message.closeable,
    hierarchy: custom_message.hierarchy,
    type: custom_message.message_type,
    title: (_custom_message$title = custom_message.title) === null || _custom_message$title === void 0 ? void 0 : _custom_message$title.text
  }, /*#__PURE__*/_jsx("div", {
    className: `${namespace$1}__message__text`
  }, void 0, componentEnhance.jsx(custom_message.body.text, custom_message.body.values))), /*#__PURE__*/_jsx("p", {
    "data-testid": "content",
    className: `${namespace$1}__content`
  }, void 0, nl2br(content)));
};
const namespace = 'ui-pdp-description-collapse';
const namespaceRex$1 = 'ui-pdp-description-collapse-rex';
const FEATURE_NAME_REX$1 = 'description_rex';
const DescriptionDesktop = _ref => {
  let {
    action,
    className = '',
    content,
    custom_message = null,
    title,
    show_title = true,
    collapsable = null,
    show_track = null,
    component_id,
    forceShowAction = false,
    runCatchErrorBoundary = () => {}
  } = _ref;
  try {
    const handleClick = () => {
      updateComponentPositionWhenSticky('center');
    };
    return isCollapsable(collapsable) ? /*#__PURE__*/_jsx(ActionCollapsable, {
      action: action,
      scrollToTop: false,
      onClickAction: handleClick,
      maxCollapsed: collapsable === null || collapsable === void 0 ? void 0 : collapsable.height,
      collapseBy: collapsable === null || collapsable === void 0 ? void 0 : collapsable.collapse_by,
      className: classnames(className, namespace, {
        [namespaceRex$1]: FEATURE_NAME_REX$1 === component_id
      }),
      show_track: show_track,
      forceShowAction: forceShowAction
    }, void 0, /*#__PURE__*/_jsx(Description, {
      content: content,
      title: title,
      custom_message: custom_message,
      show_track: show_track,
      showTitle: show_title
    })) : /*#__PURE__*/_jsx(Description, {
      className: className,
      content: content,
      title: title,
      custom_message: custom_message,
      show_track: show_track
    });
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};
const namespaceRex = 'ui-pdp-description-collapse-rex';
const FEATURE_NAME_REX = 'description_rex';
const DescriptionMobile = _ref => {
  let {
    action,
    className = '',
    content,
    custom_message = null,
    maxPages = 400,
    minPages = 1.5,
    title,
    collapsable = null,
    show_track = null,
    show_title = true,
    id,
    forceShowAction = false
  } = _ref;
  const setMaxCollapsed = (collapsable === null || collapsable === void 0 ? void 0 : collapsable.height) || maxPages;
  return /*#__PURE__*/_jsx(ActionCollapsable, {
    action: action,
    max: minPages,
    maxCollapsed: setMaxCollapsed,
    collapseBy: collapsable === null || collapsable === void 0 ? void 0 : collapsable.collapse_by,
    scrollToTop: false,
    className: classnames(className, {
      [namespaceRex]: FEATURE_NAME_REX === id
    }),
    forceShowAction: forceShowAction
  }, void 0, /*#__PURE__*/_jsx(Description, {
    content: content,
    title: title,
    custom_message: custom_message,
    show_track: show_track,
    showTitle: show_title
  }));
};
export { Description, DescriptionCustomMessage, DescriptionDesktop, DescriptionMobile, DescriptionTextContent, isCollapsable, nl2br };
